<template>
  <div class="h-auto d-flex justify-content-center">
    <div class="w-100 m-0 max-width-1400 h-100" v-if="ready_campaign">
      <div class="container-invitation d-block d-md-flex">
        <left-side :campaign="campaign" :owner="owner" class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-9 h-auto flex-1"/>
        <right-side :campaign="campaign" :owner="owner" class="col-12 col-md-12 col-lg-4 col-xl-3 flex-1 card mb-0 p-0 pb-2 custom-card-borders-style-invitation-right"/>
      </div>
    </div>
  </div>
</template>

<script>
import invitation_service from "@/services/invitation";

export default {
  name: "newInvitationDetail",
  data() {
    return {
      campaign: {},
      ready_campaign: false,
      owner: null,
    };
  },
  components: {
    leftSide: () => import('@/views/components/invitation/leftSide.vue'),
    rightSide: () => import('@/views/components/invitation/rightSide.vue'),
  },
  beforeMount() {
    this.owner = this.$route.params.owner;
  },
  created() {
    this.getCampaign();
  },
  methods: {
    plusContent() {
      this.total_contents += 1;
    },
    getCampaign() {
      const { slug, username, network} = this.$route.params;
      invitation_service.getInvitation(slug, network, username).then((response) => {
        this.campaign = response;
        this.ready_campaign = true;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container-invitation {
  align-items: stretch;
  flex-wrap: wrap;
}
.custom-card-borders-style-invitation-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.container-avatar {
  width: auto;
  position: relative;
  bottom: 4.5em;
}
.avatar-header {
  min-width: 120px;
  padding: 0.7em;
}
.avatar-influencer {
  padding: 0.7em;
}
.socialnet{
  font-size: 2em;
  position: absolute;
  right: 30%;
  top: 33%;
  background: white;
  z-index: 9;
  padding: 2%;
  border-radius: 50%;
 }
.max-width-1400 {
  max-width: 1400px;
  margin: 0 auto;
}
@media(min-width:2000px) {
  .socialnet {
    right:35%;
  }
}
@media(min-width:2900px) {
  .socialnet {
    right:40%;
  }
}
.icon-verified-invitation {
  width: 20px !important;
  height: 20px !important;
  margin-left: 0.2em;
}
.fixed-height {
  height: calc(100vh - 150px);
  overflow: scroll;
}
.no-radius {
  border-radius: 0;
  box-shadow: none;
}
.border-right-lg {
  border-right: 1px solid #EFEFEF;
}
.flex-1 {
  flex: 1;
}
</style>